import { SignUpForm } from "@/components/formik/auth/SignUpForm.tsx";
import AuthLayout from "@/components/layouts/AuthLayout";


export const SignUpView = () => {
  return (
    <div>
      <AuthLayout
        title="Create an account"
        subtitle="Sign up with qoonity to access content and features"
      >
        <SignUpForm />
      </AuthLayout>
    </div>
  );
};
